import React, { useContext, useEffect, useRef, useState, Component } from 'react'
import { Button, Carousel, Form, InputGroup, Modal } from 'react-bootstrap'
import { FaTimes } from "react-icons/fa"
import Assets from '../../constants/images'
import { AddUserIcon, FacebookIcon, InstagramIcon, LinkedinIcon, LocationIcon, TwitterIcon, YoutubeIcon, YoutubeIconWithoutBg } from '../../constants/svgs'
import TimePicker from 'react-times';
import 'react-times/css/material/default.css';
import 'react-times/css/classic/default.css';
import { Controller, useForm } from "react-hook-form";
import { SPECIAL_CHARACTER_ARRAY, SPECIAL_CHARACTER_ARRAY_FOR_ADDRESS, VALIDATIONS, VALIDATIONS_TEXT } from '../../constants/app-constants';
import { success, error } from "../../constants/msg";
import { ToastContainer } from "react-toastify";
import { CreatePostPopupContext } from "../../App";
import DateTimePicker from 'react-datetime-picker';
import { Map, GoogleApiWrapper, Marker } from "google-maps-react";
import Select from 'react-select'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

const CreatePostPopup = (props) => {
    const options = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ]

    const [value, onChange] = useState(new Date());
    const [uploadedImage, setUploadedImage] = useState([]);
    const [showLocationPickerModal, setShowLocationPickerModal] = useState(false);
    const [handleCreatePostPopup, setHandleCreatePostPopup] = useContext(CreatePostPopupContext);
    const { register, handleSubmit, reset, watch, control, setValue, formState: { errors, isValid } } = useForm({
        mode: "onChange"
    });

    let markersList = [
        { lat: 23.024000, lng: 72.580276 },
    ]
    let [markers, setMarkers] = useState(markersList);

    const mapStyles = {
        position: "relative",
        width: "100%",
        height: "100%"
    };

    let onMarkerDragEnd = (coord, index, markers) => {
        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();
        markers[index] = { lat, lng };
        setMarkers(markers);
    }

    let myMarkers = markers && Object.entries(markers).map(([key, val]) => (
        <Marker key={key} id={key} position={{
            lat: val.lat,
            lng: val.lng
        }}
            draggable={true}
            onDragend={(t, map, coord) => onMarkerDragEnd(coord, key, markers)}
        />
    ))

    const handleImageUpload = (e) => {
        setUploadedImage([...uploadedImage, ...e.target.files])
    }

    const deleteImage = (i) => {
        let temp = [...uploadedImage]
        temp.splice(i, 1)
        setUploadedImage(temp)
    }

    const onSubmit = (data) => {
        console.log(data);
        reset();
        success("Post Created")
        setTimeout(() => {
            setHandleCreatePostPopup(false)
            setShowLocationPickerModal(false)
        }, 1500)
    }

    useEffect(() => {
        // setValue("recuringTime", value)
        setValue("image", uploadedImage)
    }, [value, uploadedImage])


    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setMarkers([
                    { lat: position.coords.latitude, lng: position.coords.longitude }
                ])
            });
        }
    }, [])

    return (
        <div>
            <ToastContainer />
            <Modal
                className='location-picker-modal'
                show={showLocationPickerModal}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className="header d-flex w-100 align-items-center justify-content-between p-3  border-bottom">
                        <h6 className='p-0 m-0'>Select Your Location</h6>
                        <div onClick={() => setShowLocationPickerModal(false)} className="d-flex align-items-center justify-content-center text-center fa-times"><FaTimes /></div>
                    </div>

                    <Form encType='multipart/form-data' onSubmit={handleSubmit(onSubmit)}>
                        <Map
                            google={props.google}
                            zoom={14}
                            style={mapStyles}
                            initialCenter={
                                {
                                    lat: markers[0].lat,
                                    lng: markers[0].lng
                                }
                            }
                        >
                            {myMarkers}
                        </Map>
                    </Form>
                </Modal.Body>
            </Modal>

            <Modal
                className='create-post-modal'
                show={true}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>
                    <div className="header d-flex w-100 align-items-center justify-content-between pb-3 mb-3 border-bottom">
                        <h6 className='p-0 m-0'>Create a New Post</h6>
                        <div onClick={() => setHandleCreatePostPopup(false)} className="d-flex align-items-center justify-content-center text-center fa-times"><FaTimes /></div>
                    </div>

                    <Form encType='multipart/form-data' onSubmit={handleSubmit(onSubmit)}>
                        <div className='avatar-container d-flex align-items-center mb-3'>
                            <img src={Assets.Avatar} alt="Avatar" />
                            <h6 className='d-inline-block p-0 m-0 ms-2'>Lizzty Brands.co</h6>
                        </div>

                        <div>
                            <InputGroup className='mt-2'>
                                <Form.Control
                                    name="caption"
                                    placeholder="Add a caption"
                                    className="pt-3"
                                    as="textarea"
                                    rows={3}
                                    onKeyDown={(e) => (SPECIAL_CHARACTER_ARRAY.includes(e.key) || e.key === "0" || Number(e.key)) && e.preventDefault()}
                                    {...register("caption",
                                        {
                                            maxLength: {
                                                value: VALIDATIONS.CAPTION_MAX,
                                                message: VALIDATIONS_TEXT.CAPTION_MAX
                                            },
                                        })
                                    }
                                />
                            </InputGroup>
                            {errors.caption && <small className='text-red'>{errors.caption.message}</small>}

                            <InputGroup className='mt-2'>
                                <Form.Control
                                    onClick={() => setShowLocationPickerModal(true)}
                                    name="location"
                                    placeholder="Add a location"
                                    className="input-icon input-icon-location"
                                    onKeyDown={(e) => (SPECIAL_CHARACTER_ARRAY_FOR_ADDRESS.includes(e.key) || e.key === "0" || Number(e.key)) && e.preventDefault()}
                                    {...register("location",
                                        {
                                            maxLength: {
                                                value: VALIDATIONS.LOCATION_MAX,
                                                message: VALIDATIONS_TEXT.LOCATION_MAX
                                            },
                                        })
                                    }
                                />
                            </InputGroup>
                            {errors.location && <small className='text-red'>{errors.location.message}</small>}

                            <InputGroup className='mt-2'>
                                <Select onChange={(e) => setValue("addPeople", e)} className='w-100 custom-select-input' isMulti options={options} />
                            </InputGroup>

                            <InputGroup className='mt-2'>
                                <Form.Control
                                    readOnly
                                    placeholder="Add Image"
                                    className="bg-none input-icon input-icon-addImage"
                                />
                            </InputGroup>

                            <div className="mb-3 d-flex flex-row ">
                                <input
                                    onChange={(e) => handleImageUpload(e)}
                                    className={`form-control custom-file-input ${uploadedImage.length > 0 && "mt-15"} me-3`}
                                    name="image"
                                    id="img"
                                    type="file"
                                    multiple
                                    accept=".png, .jpeg, .jpg"
                                />

                                <Swiper
                                    // navigation
                                    modules={[Navigation]}
                                    spaceBetween={10}
                                    breakpoints={{
                                        200: {
                                            slidesPerView: 2,
                                        },
                                        300: {
                                            slidesPerView: 3,
                                        },
                                        640: {
                                            slidesPerView: 5,
                                        },
                                        768: {
                                            slidesPerView: 6,
                                        },
                                        992: {
                                            slidesPerView: 8,
                                        },
                                        1200: {
                                            slidesPerView: 10,
                                        },
                                        1300: {
                                            slidesPerView: 10,
                                        },
                                    }}
                                >
                                    {
                                        uploadedImage.length > 0 &&
                                        uploadedImage.map((v, i) => {
                                            let url = URL.createObjectURL(v)
                                            return (
                                                <SwiperSlide>
                                                    <div className="box">
                                                        <div className='icon'>
                                                            <FaTimes onClick={() => deleteImage(i)} />
                                                        </div>
                                                        <img src={url} alt="PostImage1" />
                                                    </div>
                                                </SwiperSlide>
                                            )
                                        })
                                    }
                                </Swiper>
                            </div>

                            <Controller
                                name="recuringTime"
                                control={control}
                                defaultValue={null}
                                render={
                                    () => (
                                        <DateTimePicker onChange={onChange} value={value} />
                                    )
                                }
                            />
                            {value === null && <small className='text-red'>{VALIDATIONS_TEXT.DATE_TIME_REQUIRED}</small>}

                            <InputGroup className='mt-2'>
                                <Form.Control readOnly placeholder="Select Platform(s)" className="bg-none input-icon input-icon-shareIcon" />
                            </InputGroup>

                            <div className='socialCheckbox d-flex'>
                                <div>
                                    <input
                                        type="checkbox"
                                        id='facebook'
                                        className=''
                                        {...register("socialPlatform", {
                                            required: {
                                                value: true,
                                                message: VALIDATIONS_TEXT.SOCIAL_PLATFORM_REQUIRED
                                            },
                                        })}
                                    />
                                    <label htmlFor="facebook" className='d-flex align-items-center justify-content-center text-center label-facebook'><FacebookIcon /></label>
                                </div>

                                <div>
                                    <input
                                        type="checkbox"
                                        id='twitter'
                                        className=''
                                        {...register("socialPlatform", {
                                            required: {
                                                value: true,
                                                message: VALIDATIONS_TEXT.SOCIAL_PLATFORM_REQUIRED
                                            },
                                        })}
                                    />
                                    <label htmlFor="twitter" className='d-flex align-items-center justify-content-center text-center label-twitter'><TwitterIcon /></label>
                                </div>

                                <div>
                                    <input
                                        type="checkbox"
                                        id='instagram'
                                        className=''
                                        {...register("socialPlatform", {
                                            required: {
                                                value: true,
                                                message: VALIDATIONS_TEXT.SOCIAL_PLATFORM_REQUIRED
                                            },
                                        })}
                                    />
                                    <label htmlFor="instagram" className='d-flex align-items-center justify-content-center text-center label-instagram'><InstagramIcon /></label>
                                </div>

                                <div>
                                    <input
                                        type="checkbox"
                                        id='linkedin'
                                        className=''
                                        {...register("socialPlatform", {
                                            required: {
                                                value: true,
                                                message: VALIDATIONS_TEXT.SOCIAL_PLATFORM_REQUIRED
                                            },
                                        })}
                                    />
                                    <label htmlFor="linkedin" className='d-flex align-items-center justify-content-center text-center label-linkedin'><LinkedinIcon /></label>
                                </div>

                                <div>
                                    <input
                                        type="checkbox"
                                        id='youtube'
                                        className=''
                                        {...register("socialPlatform", {
                                            required: {
                                                value: true,
                                                message: VALIDATIONS_TEXT.SOCIAL_PLATFORM_REQUIRED
                                            },
                                        })}
                                    />
                                    <label htmlFor="youtube" className='d-flex align-items-center justify-content-center text-center label-youtube'><YoutubeIconWithoutBg /></label>
                                </div>
                            </div>
                            {errors.socialPlatform && <small className='text-red'>{errors.socialPlatform.message}</small>}

                            <Button disabled={value === null} type="submit" className="w-100 mt-5 btn-create-post">CREATE POST</Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyANqpbqOxMaZuvmhp7BE_8Y2om5fghSDQw"
})(CreatePostPopup);
